import createReactClass from 'create-react-class';
import Morearty from 'morearty';
import React from 'react';
import styled from 'styled-components';

import ActionMixin from 'components/lib/action_mixin';
import AddCustomerButton from 'components/customer/add_customer_button';
import AgentHomeIllustration from './agent_inbox/agent_home_illustration';
import AgentInbox from './agent_inbox';
import connect from 'components/lib/connect';
import { Device } from 'scripts/lib/device_detector';
import useDevice from 'components/hooks/use_device';
import PageLayout from './page_layout';
import Spinner from 'components/common/spinner_two';
import TeamInboxesMenu from './agent_inbox/team_inboxes_menu';

const AgentHome = createReactClass({
  mixins: [ActionMixin, Morearty.Mixin],

  /* rendering */

  render() {
    const { isPhone } = this.props;

    if (this.props.isLoading) {
      return (
        <LoadingPageLayout>
          <SpinnerContainer>
            <Spinner />
          </SpinnerContainer>
        </LoadingPageLayout>
      );
    }

    if (this.props.isInboxesViewAllEnabled) {
      // On phone, show either the inbox list OR the team inbox content (not both).
      if (isPhone) {
        return this.props.hasSelectedTeamInbox ? this.renderMobileInbox() : this.renderMobileInboxList();
      }

      return (
        <StyledPageLayout className="agentHome-pageLayout" id="agent-home">
          <div className="agent-home-body">
            {this.renderSideNav()}
            {this.renderInbox()}
          </div>
        </StyledPageLayout>
      );
    }

    return (
      <HomePageLayout className="agentHome-pageLayout" id="agent-home">
        <AgentHomeIllustration hasConversationGeneral={this.props.hasConversationGeneral} />
      </HomePageLayout>
    );
  },

  renderMobileInboxList() {
    const teamInboxCounts = this.getDefaultBinding().get('teamInboxCounts');

    return (
      <MobilePageLayout className="agentHome-pageLayout" id="agent-home">
        <MobileInboxListHeader>Team Inboxes</MobileInboxListHeader>
        <MobileInboxList>
          <TeamInboxesMenu teamInboxCounts={teamInboxCounts} />
        </MobileInboxList>
      </MobilePageLayout>
    );
  },

  renderMobileInbox() {
    return (
      <MobilePageLayout className="agentHome-pageLayout" id="agent-home">
        <MobileInboxContent>
          <AgentInbox />
        </MobileInboxContent>
      </MobilePageLayout>
    );
  },

  renderSideNav() {
    if (!this.props.isInboxesViewAllEnabled) {
      return null;
    }

    const teamInboxCounts = this.getDefaultBinding().get('teamInboxCounts');

    return (
      <div className="agentHome-sidenav-col">
        <TeamInboxesMenu teamInboxCounts={teamInboxCounts} />
      </div>
    );
  },

  renderInbox() {
    if (this.props.isInboxesViewAllEnabled) {
      return (
        <div className="agentHome-inbox main-column">
          <div className="agentHome-inbox-container">
            <AgentInbox />
            {this.props.hasConversationGeneral && <AddCustomerButton />}
          </div>
        </div>
      );
    }

    return null;
  },
});

const ConnectedAgentHome = connect(mapStateToProps)(AgentHome);

// Sources `isPhone` from DeviceContext rather than calling getDevice() inside
// mapStateToProps, which would bypass the provider and drift from the in-tree
// classification on resize. Mirrors the pattern in customer.jsx.
function AgentHomeContainer(props) {
  const isPhone = useDevice() === Device.Phone;
  return <ConnectedAgentHome {...props} isPhone={isPhone} />;
}

function mapStateToProps({ getProvider, isFeatureEnabled }) {
  const currentLocation = getProvider('currentLocation').get();

  return {
    currentLocation,
    hasConversationGeneral: isFeatureEnabled('conversation:general'),
    hasSelectedTeamInbox: currentLocation.isTeam && !!currentLocation.routingGroupId,
    isInboxesViewAllEnabled: isFeatureEnabled('inboxes:viewAll'),
    isLoading: getProvider('routingGroups').isLoading(),
  };
}

export { AgentHome };

const SpinnerContainer = styled.div`
  height: 64px;
  width: 64px;
`;

const StyledPageLayout = styled(PageLayout)`
  background-color: transparent;
  display: flex;
  flex: 1;
  flex-direction: column;
  height: 100%;
  margin: 0 auto;
  min-width: 1000px;
  width: auto;
`;

const LoadingPageLayout = styled(StyledPageLayout)`
  background-color: ${p => p.theme.colors.gray100};
  min-width: inherit;
  .page-childrenContainer {
    align-items: center;
    display: flex;
    flex-grow: 1;
    justify-content: center;
    height: 100%;
  }
`;

const HomePageLayout = styled(StyledPageLayout)`
  background-color: ${p => p.theme.colors.gray100};
  min-width: inherit;
`;

const MobilePageLayout = styled(PageLayout)`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const MobileInboxListHeader = styled.div`
  color: ${p => p.theme.colors.gray700};
  font-size: 20px;
  font-weight: 600;
  padding: 16px 16px 8px;
`;

const MobileInboxList = styled.div`
  flex: 1;
  overflow-y: auto;

  .agentGroups-header {
    font-size: var(--font-size-base);
    font-weight: 600;
    padding: 16px 16px 4px;
    text-transform: uppercase;
  }

  .agentHomeNavList {
    padding: 0;
  }

  .agentHomeNavList-item {
    padding: 0;
  }

  .agentHomeNavList-item-text {
    border-bottom: 1px solid var(--color-gray200, #e5e5e5);
    font-size: var(--font-size-medium);
    padding: 14px 16px;
  }

  .agentHomeNavList-item-count {
    color: var(--color-gray500, #737373);
    font-size: var(--font-size-base);
  }
`;

const MobileInboxContent = styled.div`
  flex: 1;
  overflow: auto;

  .agentInboxWrapper {
    padding-left: 0;
  }

  .agentInbox-topBar {
    margin-right: 0;
    padding: 8px 12px 4px;
  }

  .agentInbox-infiniteList > div {
    max-width: 100%;
  }
`;

export default AgentHomeContainer;
